import { Link } from "react-router-dom";
import { FOOTER, COMPANY } from "@/data/site";
import { CopyInstall } from "@/components/site/CopyInstall";

const FootLink = ({ link }) =>
  link.external ? (
    <a
      href={link.href}
      target="_blank"
      rel="noreferrer"
      className="text-sm text-mist transition-colors duration-300 hover:text-bone"
    >
      {link.label}
    </a>
  ) : (
    <Link to={link.to} className="text-sm text-mist transition-colors duration-300 hover:text-bone">
      {link.label}
    </Link>
  );

export const Footer = () => (
  <footer data-testid="footer" className="relative border-t border-white/10 bg-ink">
    <div className="mx-auto max-w-[1400px] px-5 py-16 md:px-10 md:py-24">
      <div className="grid gap-12 lg:grid-cols-12">
        <div className="lg:col-span-4">
          <img src="/brand/lockup-white.webp" alt="DataFrontier" className="h-7 w-auto" />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-mist">
            A research lab building memory as infrastructure — sovereign, verifiable, and yours.
          </p>
          <div className="mt-8 max-w-xs">
            <CopyInstall variant="inline" />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-10 sm:grid-cols-3 lg:col-span-8 lg:grid-cols-5">
          {FOOTER.map((col) => (
            <div key={col.title}>
              <h4 className="font-mono text-xs uppercase tracking-[0.18em] text-bone/50">{col.title}</h4>
              <ul className="mt-5 space-y-3">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <FootLink link={l} />
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 text-xs text-mist md:flex-row md:items-center md:justify-between">
        <div>
          <span className="text-bone/70">{COMPANY.legalName}</span> · {COMPANY.city}
          <span className="mx-2 opacity-40">|</span>
          <span className="font-mono">CIN {COMPANY.cin}</span>
        </div>
        <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
          <a href={`mailto:${COMPANY.emails.hello}`} className="hover:text-bone">
            {COMPANY.emails.hello}
          </a>
          <span>© {new Date().getFullYear()} DataFrontier</span>
        </div>
      </div>
    </div>
  </footer>
);
